var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"200px"}},[_c('monaco-editor-control',{model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }